import React from "react";
import { Cell, Label, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import colorCodes from "../../../../../Components/Utils/ColorCode";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import capitalizeFirstLetter from "../../../../../Components/Utils/Funcs";

function OrdersByRegionProDash() {
  const { data, loading } = UseGetDashBoardData("/dashboard/suppliers-by-region");

  const status = {
    proTeam:
      data?.suppliers_by_country?.map((item) => ({
        name: item.country || "Other",
        value: item.count || 0,
      })) || [],
  };

  const totalRequests = status.proTeam.reduce((total, item) => total + item.value, 0);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300 h-full flex flex-col justify-between">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 002 2h1.5a2.5 2.5 0 002.5-2.5V7a2 2 0 00-2-2h-1.064M15 20.488V18a2 2 0 012-2h3.064" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Orders by Region</h3>
        </div>

        <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200/50">
          {totalRequests} Regions
        </span>
      </div>

      {loading ? (
        <div className="h-52 flex items-center justify-center animate-pulse">
          <div className="h-36 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-center flex-1">
          {/* Donut Chart */}
          <div className="md:col-span-5 relative flex justify-center items-center h-44">
            {totalRequests > 0 ? (
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={status.proTeam}
                    cx="50%"
                    cy="50%"
                    innerRadius={38}
                    outerRadius={58}
                    paddingAngle={3}
                    dataKey="value"
                    stroke="none"
                  >
                    {status.proTeam.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={colorCodes[index % colorCodes.length]} />
                    ))}
                    <Label
                      value={`${totalRequests}`}
                      position="center"
                      style={{ fontSize: "15px", fontWeight: "bold", fill: "#1F2937" }}
                    />
                  </Pie>
                  <Tooltip
                    contentStyle={{
                      backgroundColor: "#1F2937",
                      borderRadius: "8px",
                      color: "#FFF",
                      border: "none",
                      fontSize: "11px",
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center text-gray-400 text-xs font-medium">No Region Data</div>
            )}
          </div>

          {/* Region Progress Bars */}
          <div className="md:col-span-7 max-h-48 overflow-y-auto pr-1 space-y-2">
            {status.proTeam.map((item, idx) => {
              const color = colorCodes[idx % colorCodes.length];
              const percent = totalRequests > 0 ? Math.round((item.value / totalRequests) * 100) : 0;
              return (
                <div key={idx} className="p-2 rounded-xl bg-gray-50/70 hover:bg-gray-100/80 transition-all duration-200">
                  <div className="flex justify-between items-center mb-1">
                    <div className="flex items-center space-x-2">
                      <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: color }}></span>
                      <span className="text-xs font-semibold text-gray-700 truncate max-w-[120px]">
                        {capitalizeFirstLetter(item.name)}
                      </span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <span className="text-xs font-bold text-gray-900">{item.value}</span>
                      <span className="text-[10px] text-gray-400 font-medium">{percent}%</span>
                    </div>
                  </div>
                  <div className="w-full h-1.5 bg-gray-200/60 rounded-full overflow-hidden">
                    <div
                      className="h-full rounded-full transition-all duration-500"
                      style={{ width: `${percent}%`, backgroundColor: color }}
                    ></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default OrdersByRegionProDash;
